import { render, staticRenderFns } from "./RubricWidget.vue?vue&type=template&id=a4d4392a"
import script from "./RubricWidget.vue?vue&type=script&lang=js"
export * from "./RubricWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports